import type { ExternalTableSchema } from '@packages/table-builder';

export function buildTransactionsPurchaseDetailsTable(purchaseId: string): ExternalTableSchema {
  return {
    metadata: {
      title: 'Purchase Details',
      entity: 'TransactionsPurchaseDetails',
    },

    dataSource: {
      endpoint: '/api/award/api/award/purchase/{purchaseId}/purchase-detail'.replace(
        '{purchaseId}',
        purchaseId,
      ),
      method: 'GET',
      rowIdField: 'id',
      responseMapping: {
        items: 'items',
        totalCount: 'totalCount',
      },
      requestParams: {
        Sorting: 'table.sorting',
        SkipCount: 'table.pageOffset',
        MaxResultCount: 'table.pageSize',
      },
    },

    columns: [
      {
        field: 'participantDetail',
        header: 'Participant Details',
        type: 'couple',
        sortable: true,
        couple: { titleField: 'participantDetail', subtitleField: 'employeeId' },
      },
      {
        field: 'fmv',
        header: 'FMV $',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'purchaseShares',
        header: 'Purchase Shares',
        type: 'number',
        sortable: true,
        width: 150,
        align: 'center',
        format: { comma: true },
      },
      {
        field: 'offeringName',
        header: 'Offering Name',
        sortable: true,
        width: 150,
      },
      {
        field: 'awardType',
        header: 'Award Type',
        type: 'badge',
        sortable: true,
        width: 100,
        align: 'center',
        badge: {
          statusMap: {
            Qualified: 'success',
            'Non Qualified': 'error',
          },
          defaultVariant: 'info',
        },
      },
      {
        field: 'offeringPeriodStartDate',
        header: 'Offering Period Start Date',
        type: 'date',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'offeringPrice',
        header: 'Offering Price',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'discount',
        header: 'Discount',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'purchaseDate',
        header: 'Purchase Date',
        type: 'date',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'purchasePrice',
        header: 'Purchase Price',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'contribution',
        header: 'Contribution',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'totalCost',
        header: 'Total Cost',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'remainder',
        header: 'Remainder',
        sortable: true,
        width: 150,
        align: 'center',
      },
      {
        field: 'isTaxCertificationVerified',
        header: 'Tax Certification',
        type: 'badge',
        sortable: true,
        width: 100,
        align: 'center',
        conditionalValues: { true: 'CERTIFIED', false: 'UNCERTIFIED' },
        badge: {
          statusMap: { true: 'success', false: 'error' },
          defaultVariant: 'info',
        },
      },
      {
        field: 'taxCollection',
        header: 'Tax Collection Status',
        type: 'badge',
        sortable: true,
        width: 150,
        align: 'center',
        visibility: 'picker',
        badge: {
          statusMap: {
            Successful: 'success',
            Expired: 'error',
            Rejected: 'error',
            'Partially Cancelled': 'error',
          },
          defaultVariant: 'info',
        },
      },
      {
        field: 'settlementType',
        header: 'Settlement Type',
        sortable: true,
        width: 150,
        align: 'center',
      },
    ],

    actions: {
      row: [{ id: 'VIEW_TRANSACTIONS_PURCHASEDETAILS', label: 'View Details' }],
    },

    features: {
      search: { enabled: false },
      pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    },
  };
}
